<script setup lang="ts">
import { computed } from 'vue'

import ReportSummaryDefectMeasurements from './ReportSummaryDefectMeasurements.vue'
import HeatmapVisualizer from './heatmapVisualizer/HeatmapVisualizer.vue'

interface PropTypes {
  measurementsSummaryData,
  measurementDataLoading
  annotations,
  annotationsLoading,
  aircraft,
  aircraftLoading
}

const props = defineProps<PropTypes>()

const defects = computed(() => {
  if (!props.annotations ) return []
  if( !Array.isArray(props.annotations) ) return []
  return props.annotations
})

const aircraft = computed(() => {
  if (!props.aircraft) return {}
  return props.aircraft[0] || {}
})
</script>

<template>
  <div id="summary-header">
    <div class="">
      <div class="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-6 mb-6">
        <div
          class="relative h-full w-full flex items-center justify-end bg-slate-200 rounded-md border border-slate-100 shadow-md shadow-black/20 overflow-hidden p-4"
        > 
          <ReportSummaryDefectMeasurements v-loading="props.measurementDataLoading"  :measurements-summary-data="props?.measurementsSummaryData" />
        </div>
        <div class="bg-slate-200 rounded-md border border-slate-300 p-4 shadow-md shadow-black/20 p-4">
          <div class="h-full w-full rounded-t-md">
            <div>
              <div class="flex items-center">
                <div class="h-8 flex items-center text-slate-600 font-semibold mt-2 mb-4">Defect View</div>
              </div>
              <div style=" height: 250px;">
                <div class="relative h-full grid grid-rows-[minmax(80%,_100%)_auto] grid-cols-1" style="width: 100%;">
                  <HeatmapVisualizer v-loading="props.annotationsLoading || props.aircraftLoading"  :aircraft="aircraft" :defects="defects" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
